import { computed, signal } from '@lit-labs/signals';
export const DEFAULT_LIT_STARTER_NAME = 'World';
const nameSignal = signal(DEFAULT_LIT_STARTER_NAME);
const clickCountSignal = signal(0);
const lastInteractionSignal = signal(null);
export const litStarterState = computed(() => {
    const name = nameSignal.get();
    return {
        name,
        greeting: `Hello, ${name}!`,
        clickCount: clickCountSignal.get(),
        lastInteractionTs: lastInteractionSignal.get(),
    };
});
export function setLitStarterName(rawName) {
    const name = rawName.trim() || DEFAULT_LIT_STARTER_NAME;
    if (nameSignal.get() === name) {
        return;
    }
    nameSignal.set(name);
    markInteraction();
}
export function incrementLitStarterCount() {
    clickCountSignal.set(clickCountSignal.get() + 1);
    markInteraction();
}
export function resetLitStarterState() {
    nameSignal.set(DEFAULT_LIT_STARTER_NAME);
    clickCountSignal.set(0);
    lastInteractionSignal.set(null);
}
function markInteraction() {
    lastInteractionSignal.set(Date.now());
}
//# sourceMappingURL=lit-starter.store.js.map